import { Box, PaletteColor, Typography } from '@mui/material';
import { theme } from '../../theme';

export const Pill = (props: { text: string, pallet?: PaletteColor }) => {
  const colorToUse = props.pallet ?? theme.palette.success;
  return <Box
    sx={{
      ml: 4,
      display: 'inline-flex',
      p: '2px 8px',
      alignItems: 'center',
      borderRadius: '16px',
      border: '1px solid',
      borderColor: colorToUse[200],
      background: colorToUse[50],
    }}
  >
    <Typography variant="textXS"
      sx={{ color: colorToUse[700] }}>
      {props.text}
    </Typography>
  </Box>;

};